"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManufacturerDto = void 0;
class ManufacturerDto {
    constructor(params) {
        this.name = "";
        this.iconFileName = "";
        this.iconContentType = "";
        this.iconUpdatedAt = "";
        this.createdAt = "";
        this.updatedAt = "";
        this.actionBarIconFileName = "";
        this.actionBarIconContentType = "";
        this.actionBarIconUpdatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.name = params.name;
        this.iconFileName = params.iconFileName;
        this.iconContentType = params.iconContentType;
        this.iconFileSize = params.iconFileSize;
        this.iconUpdatedAt = params.iconUpdatedAt;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.actionBarIconFileName = params.actionBarIconFileName;
        this.actionBarIconContentType = params.actionBarIconContentType;
        this.actionBarIconFileSize = params.actionBarIconFileSize;
        this.actionBarIconUpdatedAt = params.actionBarIconUpdatedAt;
    }
}
exports.ManufacturerDto = ManufacturerDto;
//# sourceMappingURL=ManufacturerDto.js.map